<ng-container *ngIf="element.type === 'human-body'">
  <ng-container *ngIf="testLoaded; else placeholderText">
    <div>
      <canvas id="humanBodyCtx-{{ page?.id }}-{{ element.slug }}" [style.border]="element.showBorder ? 'solid 1px #cccccc' : 'none'"></canvas>
    </div>
  </ng-container>

  <ng-template #placeholderText>
    <p>Loading your test data...</p>
  </ng-template>
</ng-container>
